import { Input, InputNumber } from 'antd';

import { styled } from '@mui/material';

export const InputStyled = styled(Input)`
  height: 40px;
  &:hover,
  &:focus,
  &:not([value='']) {
    border-color: ${({ theme }) => theme.vars.palette.primary.main};
  }
`;
export const TextAreaStyle = styled(Input.TextArea)`
  height: 200px;
  &:hover,
  &:focus,
  &:not([value='']) {
    border-color: ${({ theme }) => theme.vars.palette.primary.main};
  }
`;

export const InputNumberStyled = styled(InputNumber)`
  height: 40px;
  width: 100%;
  &:hover,
  &:focus,
  &:not([value='']) {
    border-color: ${({ theme }) => theme.vars.palette.primary.main};
  }
`;
